var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartSankey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.68 10.47a.514.514 0 00-.418.206l-4.552 5.79a3.7 3.7 0 01-2.912 1.416H3.588c-.88 0-1.588-.708-1.588-1.588 0-.88.708-1.588 1.588-1.588h12.203a.514.514 0 00.417-.205l4.553-5.79a3.7 3.7 0 012.912-1.417h12.739c.88 0 1.588.708 1.588 1.588 0 .88-.708 1.589-1.588 1.589H23.679zm-7.65 13.765l3.573 5.07a.53.53 0 00.43.224h16.379c.88 0 1.588.709 1.588 1.589s-.708 1.588-1.588 1.588H20.04a3.706 3.706 0 01-3.031-1.569l-4.87-6.902h-8.55c-.88 0-1.589-.708-1.589-1.588 0-.88.708-1.588 1.588-1.588h32.824c.88 0 1.588.708 1.588 1.588 0 .88-.708 1.588-1.588 1.588H16.029z",
    fill: "#fff"
  })));
}
export default SvgChartSankey;